// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/bluetooth.js';

import { paths } from '../generated/bluetooth';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('bluetooth', Original, paths);
